import BossModel from "@/models/BossModel";
import PersonalDetail from "@/models/WebsiteOffer/PersonalDetail";
import Proposal from "@/models/Proposal/Proposal";
import Package from "@/models/Package/Package";
import Composition from "@/models/Product/Detail/Composition/Composition";

export default class PackageRequest extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-offer/package-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteOfferPackageRequests';

    static fields() {
        return {
            id: this.attr(null),
            website_offer_personal_detail_id: this.attr(null),
            start_date: this.attr(null),
            total_visible_price: this.attr(null),
            end_date: this.attr(null),
            package_id: this.attr(null),
            package_renewable_composition_id: this.attr(null),
            package_optional_line_ids: this.attr(null),
            need_tickets: this.attr(null),
            created_at: this.attr(null),
            personal_detail: this.belongsTo(PersonalDetail, 'website_offer_personal_detail_id'),
            renewableComposition: this.belongsTo(Composition, 'package_renewable_composition_id'),
            package: this.belongsTo(Package, 'package_id'),
        }
    }

    /**
     *
     * @param newProposal
     * @returns {Promise<Collections>}
     * @constructor
     */
    CreateProposal(newProposal) {
        return this.constructor.api().action(this.id + '/create-proposal')
            .create(newProposal, false).then((response) => {
                return Proposal.insert({data: response});
            });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PersonalDetail() {
        return this.getRelated('personal_detail');
    }
}
